import { LazyLoader } from "@bp/ui-components";
import classNames from "classnames";
import { Suspense } from "react";
import { Outlet } from "react-router-dom";
import { AppHeader } from "./components/AppHeader/AppHeader";
import { Breadcrumb } from "./components/Breadcrumb/Breadcrumb";
import { Sidebar } from "./components/Sidebar/Sidebar";
import { useAppLayout } from "./contexts/AppLayoutContext";
import styles from "./DataLoader.module.css";
import { useSearchData } from "./hooks/useSearchData";

/**
 * The visual app shell: sidebar-slot + header + scrollable content area with the
 * breadcrumb and the routed page (`Outlet`). Providers and auth guards live in
 * `AppLayout`; this component is purely the layout grid.
 */
export function DataLoader() {
  const { scrollRef, sidebarIsFixed } = useAppLayout();
  const searchData = useSearchData();
  // Pinning the sidebar open makes room by shifting the content/header to the
  // expanded inset; transient hover-expand still overlays (no reflow).
  return (
    <div className={classNames(styles.app, { [styles.expanded]: sidebarIsFixed })}>
      <div className={styles["sidebar-slot"]}>
        <Sidebar />
      </div>
      <AppHeader data={searchData} />
      <div className={styles.content} id="content" ref={scrollRef}>
        <main className={styles.container}>
          <Breadcrumb />
          <Suspense fallback={<LazyLoader />}>
            <Outlet />
          </Suspense>
        </main>
      </div>
    </div>
  );
}
